var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditDatasetIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "edit_dataset_icon",
  d: "M11.5 19H9l2 2.5 2-2.5zm-1-13H13V4H9v2zm0 1H9v11h1.5zm1 0v11H13V7zM8 19V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v15l-2.6 3.467a.5.5 0 0 1-.8 0z"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  fill: "#435370",
  fillRule: "nonzero",
  transform: "rotate(45 11 12.833)",
  xlinkHref: "#edit_dataset_icon"
})));
export default SvgEditDatasetIcon;